import React from"react";
import WishlistButton from "./WishlistButton";
function HomeKitchen(){
    return <div className="Home & Kitchen"> 
    <div className ="card">
<div className="catalog-section-title"><h1>Pressure Cooker</h1></div>
<div className="row">

    <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Prestige Nakshatra Plus Red Handi 3 L.jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Prestige Nakshatra Plus Red Handi 3 L Pressure Cooker</h6>
<p>Prestige Nakshatra Plus Red Handi 3 L Induction Bottom Pressure Cooker  (Aluminium)</p>
<h4> ₹1,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

    <div className="pricing-column col-lg-4 col-md-6">
  <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Hawkins Contura Black 3 L Pressure Cooker.jpeg"} alt="" /></div>
<div className="card-header"><h6>Hawkins Contura Black 3 L Pressure Cooker</h6><p>Prestige Nakshatra Plus Red Handi 3 L Induction Bottom Pressure Cooker  (Aluminium)</p><h4> ₹1,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Greenchef Castor Hard Anodized Innerlid 2 L Induction Bottom Pressure Cooker.jpeg"} alt="" /></div>
<div className="card-header"><h6>Greenchef Castor Hard Anodized Innerlid 2 L Induction Bottom Pressure Cooker</h6><p>Greenchef Castor Hard Anodized Innerlid 2 L Induction Bottom Pressure Cooker  (Hard Anodized)</p><h4> ₹1,199 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>



<div className ="card">
<div className="catalog-section-title"><h1>Pans</h1></div>
<div className="row">

    <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Renberg Blue Orchid Fry Pan.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Renberg Blue Orchid Fry Pan </h6><p>Renberg Blue Orchid Fry Pan 24 cm diameter  (Aluminium, Non-stick)</p><h4> ₹349 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

   <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Renberg Hard Anodised Fry Pan 24.jpeg"} alt="" /></div>
<div className="card-header"><h6>Renberg Hard Anodised Fry Pan 24 </h6><p>Renberg Hard Anodised Fry Pan 24 cm diameter  (Hard Anodised)</p><h4> ₹699 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

   <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Nirlep Selec+ J Class 26 Cm Non Stick Induction Fry Pan.jpeg"} alt="" /></div>
<div className="card-header"><h6>Nirlep Selec+ J Class 26 Cm Non Stick Induction Fry Pan</h6><p>Nirlep Selec+ J Class 26 Cm Non Stick Induction Fry Pan, 3 mm Stir Fry Pan 26 cm diameter  (Aluminium, Non-stick, Induction Bottom)</p><h4> ₹929 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>

<div className ="card">
<div className="catalog-section-title"><h1>Dinner Set</h1></div>
<div className="row">

    <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Cutting EDGE Pack of 101 Plastic Ultra Light.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Cutting EDGE Pack of 101 Plastic Ultra Light</h6><p>Cutting EDGE Pack of 101 Plastic Ultra Light - Porcelain Look (Microwave Safe, BPA Free) Dinner Set  (Microwave Safe)</p><h4> ₹2,915</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/birdy Pack of 40 Melamine Dinner Set.jpeg"} alt="" /></div>
<div className="card-header"><h6>birdy Pack of 40 Melamine Dinner Set</h6><p>birdy Pack of 40 Melamine Dinner Set</p><h4> ₹1,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Borosil Pack of 33 Opalware Royal Brown Dinner Set.jpeg"} alt="" /></div>
<div className="card-header"><h6>Borosil Pack of 33 Opalware Royal Brown Dinner Set </h6><p>Borosil Pack of 33 Opalware Royal Brown Dinner Set  (Microwave Safe)</p><h4> ₹3,295</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>

 <div className ="card">
<div className="catalog-section-title"><h1>Microwave Oven </h1></div>
<div className="row">
  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Whirlpool 20 L Solo Microwave Oven.jpeg"} alt="" /></div>
<div className="card-header"><h6>Whirlpool 20 L Solo Microwave Oven </h6><p>Whirlpool 20 L Solo Microwave Oven  (MAGICOOK PRO 20SM BLACK, Black)</p><h4> ₹4,599</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Samsung 28 L Convection Microwave Oven.jpeg"} alt="" /></div>
<div className="card-header"><h6>Samsung 28 L Convection Microwave Oven </h6><p>Samsung 28 L Convection Microwave Oven  (MC28H5033CK/TL, Black)</p><h4> ₹13,499</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Samsung 23 L Solo Microwave Oven.jpeg"} alt="" /></div>
<div className="card-header"><h6>Samsung 23 L Solo Microwave Oven </h6><p>Samsung 23 L Solo Microwave Oven  (MS23F301TAK/TL, Black)</p><h4> ₹5,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>

<div className ="card">
<div className="catalog-section-title"><h1>Chimneys</h1></div>
<div className="row">

    <div className="pricing-column col-lg-4 col-md-6">
  <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Elica ESCG BF 60 NERO Wall Mounted Chimney  (Black 1100 CMH).jpeg"}alt=""  /></div>
<div className="card-header"><h6>Elica ESCG BF 60 NERO Wall Mounted Chimney  (Black 1100 CMH)</h6><p>Hindware Nevio 60 Auto Clean Wall Mounted Chimney  (Brushed Silver/Inox 1200 CMH/m3/h)</p><h4> ₹11,599</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Elica WD HAC TOUCH BF 60 MS.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Elica WD HAC TOUCH BF 60 MS </h6><p>Elica WD HAC TOUCH BF 60 MS with Installation Kit Included Auto Clean Wall Mounted Chimney  (Black 1200 CMH)</p><h4> ₹12,990</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Elica ESCG BF 60 NERO Wall Mounted Chimney.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Elica ESCG BF 60 NERO Wall Mounted Chimney  </h6><p>Elica ESCG BF 60 NERO Wall Mounted Chimney  (Black 1100 CMH)</p><h4> ₹8,888</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>

<div className ="card">
<div className="catalog-section-title"><h1>Induction</h1></div>
<div className="row">

    <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Prestige PIC 20.0 Induction Cooktop.jpeg"} alt="" /></div>
<div className="card-header"><h6>Prestige PIC 20.0 Induction Cooktop</h6><p>Prestige PIC 20.0 Induction Cooktop  (Black, Push Button)</p><h4> ₹1,749</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

   <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/iBELL IBL CROWN 102 Induction Cooktop.jpeg"} alt="" /></div>
<div className="card-header"><h6>iBELL IBL CROWN 102 Induction Cooktop</h6><p>iBELL IBL CROWN 102 Induction Cooktop  (Black, Touch Panel)</p><h4> ₹1,675</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Prestige PIC 6.1 V3 Induction Cooktop.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Prestige PIC 6.1 V3 Induction Cooktop </h6><p>Prestige PIC 6.1 V3 Induction Cooktop  (Black, Touch Panel)</p><h4> ₹3,675</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>

 <div className ="card">
<div className="catalog-section-title"><h1>Electric Rice Cooker</h1></div>
<div className="row">

    <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Butterfly Wave Electric Rice Cooker.jpeg"} alt="" /></div>
<div className="card-header"><h6>Butterfly Wave Electric Rice Cooker</h6><p>Butterfly Wave Electric Rice Cooker with Steaming Feature  (1.8 L, Gold)</p><h4> ₹1,681</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Butterfly Wave Electric Rice Cooker with Steaming Feature.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Butterfly Wave Electric Rice Cooker</h6><p>Butterfly Wave Electric Rice Cooker with Steaming Feature  (1.8 L, Red)</p><h4> ₹1,630</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

   <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Butterfly Wave Electric Rice Cooker.jpeg"} alt="" /></div>
<div className="card-header"><h6>Butterfly Wave Electric Rice Cooker </h6><p>Butterfly Wave Electric Rice Cooker with Steaming Feature  (2.8 L, Gold)</p><h4> ₹1,999</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>

<div className ="card">
<div className="catalog-section-title"><h1>Wet Grinder</h1></div>
<div className="row">

    <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Prestige PWG 07 Wet Grinder.jpeg"} alt="" /></div>
<div className="card-header"><h6>Prestige PWG 07 Wet Grinder </h6><p>Prestige PWG 07 Wet Grinder  (Black)</p><h4> ₹4,395</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

 <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Elgi Ultra Grind+Gold 2.0 L Wet Grinder.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Elgi Ultra Grind+Gold 2.0 L Wet Grinder</h6><p>Elgi Ultra Grind+Gold 2.0 L Wet Grinder  (Purple)</p><h4> ₹7,490</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Rally RLY-WG-Wega Wet Grinder.jpeg"} alt="" /></div>
<div className="card-header"><h6>Rally RLY-WG-Wega Wet Grinder</h6><p>Rally RLY-WG-Wega Wet Grinder  (Burgundy)</p><h4> ₹3,996</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>


<div className ="card">
<div className="catalog-section-title"><h1>Mixer Grinder</h1></div>
<div className="row">

    <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Butterfly Rapid 4 Jar 750 watts 750 W Juicer Mixer Grinder.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Butterfly Rapid 4 Jar 750 watts 750 W Juicer Mixer Grinder</h6><p>Butterfly Rapid 4 Jar 750 watts 750 W Juicer Mixer Grinder  (Black, 4 Jars)</p><h4> ₹2,899</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Preethi Zodiac MG-218 750 W Juicer Mixer Grinder.jpeg"} alt="" /></div>
<div className="card-header"><h6>Preethi Zodiac MG-218 750 W Juicer Mixer Grinder </h6><p>Preethi Zodiac MG-218 750 W Juicer Mixer Grinder  (Black/Light Grey, 5 Jars)</p><h4> ₹7,490</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Butterfly Mixer Grinder Thunder 750 W Juicer Mixer Grinder.jpeg"} alt="" /></div>
<div className="card-header"><h6>Butterfly Mixer Grinder Thunder 750 W Juicer Mixer Grinder</h6><p>Butterfly Mixer Grinder Thunder 750 W Juicer Mixer Grinder  (Black, 4 Jars)</p><h4> ₹3,060</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>

<div className ="card">
<div className="catalog-section-title"><h1>Coffee Mug</h1></div>
<div className="row">

   <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Tuelip You Can Do It Colour Changing Magic Mug.jpeg"} alt="" /></div>
<div className="card-header"><h6>Tuelip "You Can Do It" Colour Changing Magic Coffee Mug</h6><p>Tuelip "You Can Do It" Colour Changing Magic Printed for tea & coffee Ceramic Mug  (300 ml)</p><h4> ₹311</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Tuelip Valentine Printed for Valentines Day Gift.jpeg"}alt=""  /></div>
<div className="card-header"><h6>Tuelip "Valentine" Printed for Valentines Day Gift</h6><p>Tuelip "You Can Do It" Colour Changing Magic Printed for tea & coffee Ceramic Mug  (300 ml)</p><h4> ₹369</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Tuelip Full Black Be Mine Printed Cup For Valentines Day Gift.jpeg"} alt="" /></div>
<div className="card-header"><h6>Tuelip Full Black "Be Mine" Printed Cup For Valentines Day Gift</h6><p>Tuelip Full Black "Be Mine" Printed Cup For Valentines Day Gift For Your Love One, Tea And Coffee 350 Ml Ceramic Cup Ceramic Mug  (350 ml)</p><h4> ₹324</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>

<div className ="card">
<div className="catalog-section-title"><h1>Water Bottles</h1></div>
<div className="row">

    <div className="pricing-column col-lg-4 col-md-6">
<div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Tuelip Trendy Sporty Look For Sports.jpeg"} alt="" /></div>
<div className="card-header"><h6>Tuelip Trendy Sporty Look For Sports</h6><p>Tuelip Trendy Sporty Look For Sports,Gym,Bike Riding ,Hiking,Mountain Climbing 750 ml Water</p><h4> ₹361</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

  <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Dechef Glamour Stainless Steel 750 ml Bottle.jpeg"} alt="" /></div>
<div className="card-header"><h6>Dechef Glamour Stainless Steel 750 ml Bottle</h6><p>Dechef Glamour Stainless Steel 750 ml Bottle  (Pack of 1, Blue, Steel)</p><h4> ₹349</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>

   <div className="pricing-column col-lg-4 col-md-6">
 <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/homekitchenimages/Ozone Glacier RED 750 ml Bottle.jpeg"} alt="" /></div>
<div className="card-header"><h6>Ozone Glacier RED 750 ml Bottle  </h6><p>Ozone Glacier RED 750 ml Bottle  (Pack of 1, Red, Steel)</p><h4> ₹280</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
</div>   
</div>
</div>
</div>

</div>
}
export default HomeKitchen;